export default __webpack_public_path__ + "static/media/placeholder_dummy2016-kunstshop01-mobile-de.7536a59f.png";